<template>
  <ankh-list>
    <template #btn-group>
      <el-button @click.native="$router.push('add')">{{$t('新增')}}</el-button>
      <el-button @click.native="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #search-form>
      <el-form-item :label="$t('标题')">
        <el-input :placeholder="$t('标题')" v-model="searchForm.title" clearable/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{$t('搜索')}}</el-button>
        <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">

      <table-list
          ref="list"
          :height="height"
          :onPage="false"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>

        <el-table-column prop="num" :label="$t('编号')" fixed/>
        <el-table-column prop="title" :label="$t('标题')" fixed />
        <el-table-column prop="content" :label="$t('内容')">
          <template v-slot="{row}">
            <div class="content" v-html="row.content"></div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('移动')">
          <template v-slot="{row}">
            <notice-move :list="[...tableData]" :row="row" @change-sort="handleChangeSortList" />
          </template>
        </el-table-column>
        <el-table-column prop="releaseTime" :label="$t('发布时间')">
          <template v-slot="{row}">
            {{row.releaseTime | formatDate}}
          </template>
        </el-table-column>

        <el-table-column prop="status" :label="$t('发布状态')">
          <template v-slot="{row}">
            <dict-text dict-flag="NOTICE_RELEASE_STATUS" :status="row.releaseStatus" />
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('公告状态')">
          <template v-slot="{row}">
            {{$t(NOTICE_STATUS.getLabelByValue(row.status))}}
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('是否置顶')">
          <template v-slot="{row}">
            {{row.isTop === "yes" ? $t('是') : $t('否')}}
          </template>
        </el-table-column>
        <el-table-column prop="readCount" :label="$t('已读')"/>
        <el-table-column fixed="right" :label="$t('操作')" min-width="60">
          <template v-slot="{row}">
            <el-dropdown size="small">
              <el-button type="primary" size="small">
                {{$t('更多操作')}}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown"  style="width: 98px; text-align: center">
                <el-dropdown-item divided @click.native="handleChanageTop(row)">{{row.isTop === "yes" ? $t('取消置顶') : $t('置顶')}}</el-dropdown-item>
                <el-dropdown-item @click.native="handleChangeStatus(row)" divided >{{row.status === "open" ? $t('禁用') : $t('取消禁用')}}</el-dropdown-item>
                <el-dropdown-item @click.native="$router.push('detail?code=' + row.code)" divided>{{$t('查看')}}</el-dropdown-item>
                <el-dropdown-item @click.native="$router.push('edit?code=' + row.code)" divided>{{$t('编辑')}}</el-dropdown-item>
                <el-dropdown-item @click.native="handleDelete(row)" divided>{{$t('删除')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </table-list>
    </template>
  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import {NOTICE_STATUS} from "@/constant/constant";
import NoticeMove from "@/components/notice-move/NoticeMove";
import DictText from "@/components/dict/DictText";
import AnkhList from "@/components/list/AnkhList.vue";

export default {
  name: "NoticeList",
  components: {AnkhList, DictText, NoticeMove, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      addDialog: false,
      NOTICE_STATUS,
    }
  },
  methods: {
    // 移动排序
    async handleChangeSortList(list) {
      try {
        const params = list.map((i, index) => {
          return {
            code: i.code,
            sort: index + 1,
          }
        });
        await request(this.$api.notice.saveSort, params, {isJson: true});
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },

    // 设置置顶
    async handleChanageTop(row) {
      try {
        const params = {
          code: row.code,
          isTop: row.isTop === "yes" ? "no" : "yes",
        }
        await request(this.$api.notice.updateStatus, params);
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },

    // 禁用/取消禁用
    async handleChangeStatus(row) {
      try {
        const params = {
          code: row.code,
          status: row.status === "open" ? "close" : "open"
        }
        await request(this.$api.notice.updateStatus, params);
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.notice.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      try {
        let codes = this.selection.map(item => item.code);
        if(!codes.length) {
          this.$message.warning(this.$t('请选择要删除的项'));
          return;
        }
        await requestByTip(
            this.$api.notice.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量删除操作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest(codes.length);
      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.notice.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    }
  },
}
</script>

<style scoped>

.content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
}

</style>
